// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import MobiusPage from "@insite/mobius/Page";
import * as React from "react";

const BlogPage: React.FunctionComponent<PageProps> = ({ id }) => (
    <MobiusPage>
        <Zone contentId={id} zoneName="Content" />
    </MobiusPage>
);

const pageModule: PageModule = {
    component: BlogPage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
        allowedParents: ["BlogHomePage"],
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
                sortOrder: 199,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
            {
                ...HorizontalRule,
                sortOrder: 150,
            },
            {
                name: "publishDate",
                defaultValue: null,
                editorTemplate: "DateTimeField",
                fieldType: "General",
                isRequired: true,
                sortOrder: 151,
            },
            {
                name: "authorName",
                defaultValue: "",
                editorTemplate: "TextField",
                fieldType: "General",
                sortOrder: 152,
            },
            {
                name: "authorTitle",
                defaultValue: "",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                sortOrder: 153,
            },
            {
                name: "authorImage",
                defaultValue: "",
                editorTemplate: "ImagePickerField",
                fieldType: "General",
                sortOrder: 154,
            },
            {
                name: "blogIntro",
                defaultValue: "",
                tooltip: "First paragraph of the blog post. Larger.",
                editorTemplate: "RichTextField",
                fieldType: "Translatable",
                sortOrder: 155,
            },
            {
                name: "blogShortDescription",
                defaultValue: "",
                tooltip: "Shows on the blog post card.",
                editorTemplate: "RichTextField",
                fieldType: "Translatable",
                sortOrder: 156,
            },
        ],
    },
};

export default pageModule;

export const BlogPageContext = "BlogPage";
